module.exports = __webpack_public_path__ + "01_bob_yellow.a11ea08a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_bob_yellow.png
// module id = 9RTV
// module chunks = 0